import * as THREE from 'three';
import {
    vVignetteShader, fVignetteShader,
} from '../shaders';

export class Background {
    constructor({ assets, model }) {
        const bgrGeom = new THREE.PlaneGeometry(1, 1)
        const bgrMat = new THREE.ShaderMaterial({
            uniforms: {
                time: { value: 0 },
                noiseMap: { value: assets.textures.noise },
                scale: { value: new THREE.Vector2(1, 1) },
            },
            vertexShader: vVignetteShader,
            fragmentShader: fVignetteShader,
            transparent: true,
            depthTest: false,
        })

        this.bgrBottom = new THREE.Mesh(bgrGeom, bgrMat);
        this.bgrBottom.position.set(0, 0, -0.02)
        model.add(this.bgrBottom)

        this.bgrTop = new THREE.Mesh(bgrGeom, bgrMat);
        this.bgrTop.position.set(0, 0, -0.02);
        this.bgrTop.rotation.z = Math.PI;
        model.add(this.bgrTop);
    }

    update(time) {
        this.bgrTop.material.uniforms.time.value = time;
    }

    resize(w, h) {
        this.bgrBottom.scale.x = this.bgrTop.scale.x = w + 0.2;
        this.bgrBottom.scale.y = this.bgrTop.scale.y = h * 0.2;
        this.bgrBottom.position.y = -(h * 0.5) + (h * 0.1) - 0.02;

        this.bgrTop.position.y = - this.bgrBottom.position.y;
        this.bgrTop.material.uniforms.scale.value = new THREE.Vector2(this.bgrBottom.scale.x, this.bgrBottom.scale.y);
    }
}